<template>
  <div class="keFu">
    <statistics v-loading="sLoading" :list="statistics" :data="sData"></statistics>

    <div class="card-row">
      <chart-table1 class="row-col" title="今日服务请求列表" />
    </div>

    <div class="card-row">
      <chart-table2 source="workWfp" title="未分配服务请求列表" class="row-col space-item" />
      <chart-table2 source="workWwc" title="未完成服务请求列表" class="row-col space-item" />
    </div>

    <div class="card-row">
      <chart-table2 source="serviceWwc" title="未完成现场服务单列表" class="row-col space-item" />
      <chart-table2 source="serviceYc" title="异常现场服务单列表" class="row-col space-item" />
    </div>

    <div class="card-row">
      <chart-bar1 class="row-col space-item" chart-id="bar-xc" />
      <chart-bar2 class="row-col space-item" chart-id="bar-xc2" source="accept" />
    </div>

    <div class="card-row">
      <chart-bar2 class="row-col space-item" chart-id="bar-xc3" source="finish" />
      <chart-bar3 class="row-col space-item" chart-id="bar-pp1" source="request" />
    </div>

    <div class="card-row">
      <chart-bar3 class="row-col space-item" chart-id="bar-pp2" source="scene" />
      <chart-bar3 class="row-col space-item" chart-id="bar-pp3" source="remote" />
    </div>
  </div>
</template>

<script>
import Statistics from './components/statistics'
import ChartBar1 from './components/ChartBar1'
import ChartBar2 from './components/ChartBar2'
import ChartBar3 from './components/ChartBar3'

import ChartTable1 from './components/ChartTable1'
import ChartTable2 from './components/ChartTable2'

/**
 * 客服 看板
 */
export default {
  name: 'viewKeFu',
  components: { Statistics, ChartBar1, ChartBar2, ChartBar3, ChartTable1, ChartTable2 },
  data() {
    return {
      /** @type {import('./index.vue').IRoleId */
      roleId: 'keFu',
      statistics: [
        { num: 0, field: 'ZSQ_WORK', tip: '总申请服务请求' },
        { num: 0, field: 'WWC_WORK', tip: '未完成服务请求' },
        { num: 0, field: 'WWC_SERVICE', tip: '未完成现场服务单' },
        { num: 0, field: 'WFP_WORK', tip: '未分配服务请求' },
        { num: 0, field: 'THIS_WEEK_WORK', tip: '本周总服务请求' },
        { num: 0, field: 'YWC_WORK_WDZ', tip: '已完成未对账服务请求' },
        { num: 0, field: 'YWC_WORK_WQK', tip: '已完成未请款服务请求' },
        {
          type: 'total',
          done: 0,
          unfinish: 0,
          num: 0,
          field: 'ENG_SERVICE_3',
          field_done: 'YWC_ENG_SERVICE_3',
          field_unfinish: 'WWC_ENG_SERVICE_3',
          tip: '近三天工程师忙闲情况'
        }
      ],
      sData: {},
      sLoading: false
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    getData: function() {
      let condition = {},
        roleId = this.roleId
      this.sLoading = true
      this.api.queryList('YW_STATISTICS_KEFU', { p2: condition, p9: '' }, `${roleId}_statistics`).then(
        res => {
          this.sLoading = false
          let resData = res.result
          this.sData = resData[0] || {}
        },
        err => {
          this.sLoading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewBoard/viewKeFu.vue